export default __webpack_public_path__ + "static/media/rr-color.fd0ce8b9.png";